
import React, { Suspense } from 'react';
import { Route } from 'react-router-dom';
import ProtectedRoute from '@/components/auth/ProtectedRoute';
import PageLoadingSpinner from '@/components/common/PageLoadingSpinner';
import { LazyRequestCenter, LazyStaffManagement } from './lazyRoutes';
import ProjectStatusReport from '@/components/monitoring/ProjectStatusReport';

// Ленивая загрузка для InviteUser
const LazyInviteUser = React.lazy(() => import('@/pages/staff/InviteUser'));

const withSuspense = (
  Component: React.LazyExoticComponent<React.ComponentType<Record<string, never>>>,
  fallbackMessage?: string
) => {
  return (
    <Suspense fallback={<PageLoadingSpinner message={fallbackMessage} />}>
      <Component />
    </Suspense>
  );
};

export const getAdminRoutes = (): JSX.Element[] => [
  <Route key="request-center" path="/request-center" element={
    <ProtectedRoute>
      {withSuspense(LazyRequestCenter, "Загрузка центра обращений...")}
    </ProtectedRoute>
  } />,
  <Route key="staff" path="/staff" element={
    <ProtectedRoute requiredRoles={['admin']}>
      {withSuspense(LazyStaffManagement, "Загрузка управления персоналом...")}
    </ProtectedRoute>
  } />,
  <Route key="staff-invite" path="/staff/invite" element={
    <ProtectedRoute requiredRoles={['admin']}>
      {withSuspense(LazyInviteUser, "Загрузка приглашения пользователя...")}
    </ProtectedRoute>
  } />,
  <Route key="system-status" path="/system/status" element={
    <ProtectedRoute requiredRoles={['admin']}>
      <div className="container mx-auto py-6">
        <ProjectStatusReport />
      </div>
    </ProtectedRoute>
  } />
];
